@if (show()) {
  <div class="modal overlay-black load-timeout lg-six">
    <div class="content pad" style="background-color: rgb(237, 237, 237)" tabindex="-1">
      <span class="icon-alert block"></span>
      <p class="text-center" dsContent [contentPath]="'shared.userStillThereCheck'"></p>
      <p class="text-center" dsContent [contentPath]="'shared.secureConnectionMyAccountStatus'"></p>
      <p class="text-center" dsContent [contentPath]="'shared.inactivityTimeoutMessage'"></p>
      <div class="text-center">
        <a
          (click)="continueSession()"
          id="continueSession"
          href="javascript:void(0)"
          dsContent
          [contentPath]="'shared.userMessageImStillHere'"
        ></a>
      </div>
      <div class="text-center">
        <a
          (click)="exitSession()"
          id="exitSession"
          href="javascript:void(0)"
          dsContent
          [contentPath]="'shared.statusMessage'"
        ></a>
      </div>
    </div>
  </div>
}
